// extracted by mini-css-extract-plugin
export default {"row":"SubscriptionTable_row__Drsgu","list":"SubscriptionTable_list__cCTaX"};